"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageFormats = void 0;
var bmp_1 = require("./bmp");
var cur_1 = require("./cur");
var dds_1 = require("./dds");
var gif_1 = require("./gif");
var ico_1 = require("./ico");
var jpg_1 = require("./jpg");
var png_1 = require("./png");
var psd_1 = require("./psd");
var svg_1 = require("./svg");
var webp_1 = require("./webp");
exports.imageFormats = {
  bmp: {
    is: bmp_1.isBMP,
    calculate: bmp_1.calculateBMP
  },
  cur: {
    is: cur_1.isCUR,
    calculate: ico_1.calculateICOorCUR
  },
  dds: {
    is: dds_1.isDDS,
    calculate: dds_1.calculateDDS
  },
  gif: {
    is: gif_1.isGIF,
    calculate: gif_1.calculateGIF
  },
  ico: {
    is: ico_1.isICO,
    calculate: ico_1.calculateICOorCUR
  },
  jpg: {
    is: jpg_1.isJPG,
    calculate: jpg_1.calculateJPG
  },
  png: {
    is: png_1.isPNG,
    calculate: png_1.calculatePNG
  },
  psd: {
    is: psd_1.isPSD,
    calculate: psd_1.calculatePSD
  },
  svg: {
    is: svg_1.isSVG,
    calculate: svg_1.calculateSVG
  },
  webp: {
    is: webp_1.isWebP,
    calculate: webp_1.calculateWEBP
  }
};